import script from "./LinkControl.vue?vue&type=script&lang=ts"
export * from "./LinkControl.vue?vue&type=script&lang=ts"

export default script